/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-10 17:31:00
 */

 import {Component,Prop} from 'vue-property-decorator'
 import BasicSearchPage from "../../../components/basicSearchPage/basicSearchPage";
 import override from "../../../dectorators/override";
 import SerialNumberLogService from './service/serialNumberLogService';
 import { softwareSecretKeyDOI } from './api/softwareSecretKeyApi';
 import QueryForm from 'src/components/queryForm/queryForm';
 
 @Component
 export default class SerialNumberLog extends BasicSearchPage<SerialNumberLogService, softwareSecretKeyDOI.RowDataIs> {
   @Prop({
		type: String
	})
    mn!: string
    
    checkBoxShow = false

    @override
    renderHead(h) {
        return <div></div>
    }


	@override
	loadService () {
        this.service = new SerialNumberLogService(this)
    }
 }
 